import { useEffect } from "react";
import "./style.scss"
const Singapore = () => {
    useEffect(() => {
        document.title = '港澳中文補習，幼小銜接，閱讀寫作專項';
    }, [])

    return <div className="hkonline">
        <img src="../assets/AdImg/GG.jpg" alt="" />
        <div className="icon_box">
            <a href="https://wa.me/8617788052878?text=%E4%B8%AD%E6%96%87%E8%AA%B2%E7%A8%8B%E5%92%A8%E8%A9%A2">
                <img src="../assets/whatsapp.png" alt="" className="mbs_icon" />
            </a>
        </div>
    </div>
}
export default Singapore;